import Header from "../Header";
import Footer from "../Footer";
import Breadcrumbs from "../Breadcrumbs";import BannerImg from "../assets/Images/banner5-1920x450.png";

import "./ShareLawPage.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ShareLawPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="banner">
        <img src={BannerImg} alt="" />
        <div className="banner_title res">
          <h1 className="banner-main-title">{t("share_law_page_header")}</h1>
          <p className="banner-subtitle">{t("share_law_page_header2")}</p>
        </div>
      </div>
      <Breadcrumbs>
        <Link>{t("breadcrumbs_share_law_page_link1")}</Link>
        <span>{t("breadcrumbs_share_law_page_span")}</span>
        <Link>{t("breadcrumbs_share_law_page_link2")}</Link>
      </Breadcrumbs>
      <main className="share-law-main-container">
        <section className="share-law-content-section">
          <div className="share-law-images-container">
            <img src={t("share_law_page_img1")} alt="ShareLaw Information" className="share-law-image" />
            <img src={t("share_law_page_img2")} alt="Legal Resources" className="share-law-image" />
          </div>
          <a
            className="share-law-external-link"
            href="https://www.sharelaw.org.hk/index_chi.html"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit ShareLaw website"
          >
            Visit ShareLaw Website
          </a>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ShareLawPage;
